import * as PropTypes from 'prop-types';
import * as React from 'react';

class RoutingNumberField extends React.Component {
  handleBlur(event) {
    const routingNumber = event.target.value;
    if (routingNumber.length > 0) {
      this.props.handleOnBlur({ value: routingNumber });
    }
  }

  render() {
    return (
      <div>
        <input
          className="string required wide user-success"
          maxLength={9}
          type="text"
          name={this.props.name}
          onBlur={event => this.handleBlur(event)}
        />
      </div>
    );
  }
}

RoutingNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
};

export default RoutingNumberField;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/shop/direct_checkout_profile/routing_number_field.jsx